import type { IStationTrainDefectIcon } from "../interfaces";

export const STATION_TRAIN_DEFECT_ICON_COLUMN_COUNT = 4;
export const STATION_TRAIN_DEFECT_ICON_ROW_COUNT = 2;

export const buildStationTrainDefectIconRows = (
  icons: Array<IStationTrainDefectIcon | null>,
): Array<Array<IStationTrainDefectIcon | null>> =>
  Array.from({ length: STATION_TRAIN_DEFECT_ICON_ROW_COUNT }, (_, rowIndex) =>
    Array.from(
      { length: STATION_TRAIN_DEFECT_ICON_COLUMN_COUNT },
      (_, columnIndex) => icons[rowIndex * STATION_TRAIN_DEFECT_ICON_COLUMN_COUNT + columnIndex] ?? null,
    ),
  );
